import React, { useState, useEffect } from 'react';
import { 
    Table, TableBody, TableCell, TableContainer, TableRow, Paper, 
    TableHead, Button, TablePagination, TextField, Dialog, 
    DialogActions, DialogContent, DialogContentText, DialogTitle 
} from '@mui/material';
import AddTipoObjetivo from './AddTipoObjetivo';
import Swal from 'sweetalert2';
import { useUser } from '../contexts/UserContext';
import { useAccesos } from '../contexts/AccesosContext';

function GestionTipoObjetivo() {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [tipoObjetivos, setTipoObjetivos] = useState([]);
    const [editTipoObjetivo, setEditTipoObjetivo] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialog] = useState(false);
    const [tipoObjetivoToDelete, setTipoObjetivoToDelete] = useState(null);
    const { user } = useUser();
    const { tienePermiso } = useAccesos();

    const fetchTipoObjetivos = async () => {
            try {
                const response = await fetch(`${server}/CrmTipoObjetivoCampaniums`);
                const data = await response.json();
                setTipoObjetivos(data.$values);
                console.log("Respuesta de la API:", data);
            } catch (error) {
                console.error('Error al cargar los tipos de Objetivos:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al cargar los tipos de objetivos: ' + error,
                });
            }
        };

        
        
            useEffect(() => {
                fetchTipoObjetivos();
            }, []);
        
            const handleNewTipoObjetivo= () => {
                fetchTipoObjetivos();
                setEditTipoObjetivo(null);
            };
        
            const handleChangePage = (event, newPage) => {
                setPage(newPage);
            };
        
            const handleChangeRowsPerPage = (event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
            };
        
            const handleSearchChange = (event) => {
                setSearchQuery(event.target.value);
            };
        
            const handleOpenDialog = (tipoObjetivo) => {
                setTipoObjetivoToDelete(tipoObjetivo);
                setOpenDialog(true);
            };
        
            const handleCloseDialog = () => {
                setOpenDialog(false);
                setTipoObjetivoToDelete(null);
            };
        
            const handleDeleteTipoObjetivo = async () => {
                if (tipoObjetivoToDelete) {
                    try {
                        const username = ''+user.codigoUsuario+'/';
        
                        const response = await fetch(`${server}/CrmTipoObjetivoCampaniums/${tipoObjetivoToDelete.id}/${username}`, {
                            method: 'DELETE'
                        });

                        if (response.ok) {
                            handleCloseDialog();
                            fetchTipoObjetivos();
                            Swal.fire({
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Tipo Objetivo eliminado con éxito',
                            });
                        } else {
                            handleCloseDialog();
        
                            const errorData = await response.json();
                            const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                            Swal.fire({
                                icon: 'error',
                                title: `Error ${response.status}`,
                                text: errorMessage,
                            });
                        }
                    } catch (error) {
                        console.error('Error al eliminar el tipo de objetivo:', error);
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al eliminar el tipo de objetivo: ' + error,
                        });            }
                }
            };
        
            const filteredTipoObjetivo = tipoObjetivos.filter(tipoObjetivo => tipoObjetivo.tipoObjetivo?.toLowerCase().includes(searchQuery.toLowerCase()));
        
        const handleCancelarEdicion = () => {
            setEditTipoObjetivo(null);
        };

return (
<>
    <div className="x_title">
        </div>

        <div className="x_content">
            <br />

            <AddTipoObjetivo handleNewTipoObjetivo={handleNewTipoObjetivo} editTipoObjetivo={editTipoObjetivo} cancelarEdicion={handleCancelarEdicion}/>

            <div className="ln_solid" />

            <h2>Tipos de Objetivos existentes</h2> 

            <div className="row">
                <div className="col-md-6 col-sm-4 offset-md-3">
                    <TextField
                        fullWidth
                        variant="outlined"
                        label="Buscar Tipo"
                        placeholder="Buscar..."
                        value={searchQuery}
                        onChange={handleSearchChange}
                        style={{ marginBottom: '20px' }}
                    />

                    <div className="table-responsive">
                        <TableContainer component={Paper}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Descripción</TableCell>
                                        <TableCell align="right">Acciones</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {filteredTipoObjetivo.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((tipoObjetivo) => (
                                            <TableRow key={tipoObjetivo.id}>
                                                <TableCell component="th" scope="row">
                                                    {tipoObjetivo.tipoObjetivo}
                                                </TableCell>
                                                <TableCell align="right">
                                                    <Button onClick={() => setEditTipoObjetivo(tipoObjetivo)} color="primary" disabled={!tienePermiso('Editar Tipo Objetivo')}>
                                                        Editar
                                                    </Button>
                                                    <Button onClick={() => handleOpenDialog(tipoObjetivo)} color="secondary" disabled={!tienePermiso('Eliminar Tipo Objetivo')}>
                                                        Eliminar
                                                    </Button>
                                                </TableCell>
                                            </TableRow>                                        
                                    ))}

                                   
                                </TableBody>
                            </Table>

                            <TablePagination
                                rowsPerPageOptions={[5, 10, 25]}
                                component="div"
                                count={filteredTipoObjetivo.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onPageChange={handleChangePage}
                                onRowsPerPageChange={handleChangeRowsPerPage}
                                labelRowsPerPage="Filas por página:"
                                labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`}
                            />
                        </TableContainer>

                        <Dialog open={openDialog}
                         onClose={handleCloseDialog}
                         aria-labelledby="alert-dialog-title"
                          aria-describedby="alert-dialog-description">
                            
                            <DialogTitle id="alert-dialog-title">{"Confirmar eliminación"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    ¿Estás seguro de que quieres eliminar este tipo de objetivo?
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                                <Button  onClick={handleCloseDialog} color="primary">Cancelar</Button>
                                <Button onClick={handleDeleteTipoObjetivo} color="primary" autoFocus>Eliminar</Button>
                            </DialogActions>
                        </Dialog>
                    </div>
                </div>
            </div>
        </div>
    </>

     
    );
}

export default GestionTipoObjetivo;